import cn from 'classnames'
import React from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

type ChevronIconProps = IconProps & {
  variant?: 'right' | 'left' | 'down' | 'top'
  isActive?: boolean
}

export const ChevronIcon: React.FC<React.PropsWithChildren<ChevronIconProps>> = ({
  color = theme.palette.text.default,
  size,
  variant = 'down',
  isActive,
}) => (
  <>
    <div className={cn(variant, isActive && 'active')}>
      <Icon size={size}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.20921 7.20921C5.48816 6.93026 5.94042 6.93026 6.21936 7.20921L10 10.9898L13.7806 7.20921C14.0596 6.93026 14.5118 6.93026 14.7908 7.20921C15.0697 7.48816 15.0697 7.94042 14.7908 8.21936L10.5051 12.5051C10.2261 12.784 9.77387 12.784 9.49492 12.5051L5.20921 8.21936C4.93026 7.94042 4.93026 7.48816 5.20921 7.20921Z"
            fill={color}
          />
        </svg>
      </Icon>
    </div>

    <style jsx>{`
      .right {
        transform: rotate(-90deg);
      }
      .left {
        transform: rotate(90deg);
      }
      .top,
      .down.active {
        transform: rotate(180deg);
      }
      .right.active,
      .left.active {
        transform: rotate(0deg);
      }
    `}</style>
  </>
)
